import { ErrorMessage, Field } from 'formik';
import React from 'react';
import { CardElement } from 'react-stripe-elements';
import { ErrorM } from './ErrorM';

interface FormTextFieldProps<T> {
  field: string;
  label: string;
  required: boolean;
  disabled?: boolean;

  labelPosition?: 'left' | 'right';
}

const FormStripeCardField = function <T>({
  field,
  label,
  required,
  labelPosition,
}: FormTextFieldProps<T>) {
  return (
    <div
      className={`FormBox FormSideBySide ${labelPosition ? labelPosition : ''}`}
    >
      <div className="FormLabel">
        <label>{label} </label>
      </div>
      <div className="FormField">
        <Field>
          {({ field, form }: any) => (
            <CardElement
              className={`EditBox`}
              id={'card_details'}
              onChange={(val) =>
                form.setErrors({
                  ...form.errors,
                  card_details: val.error && val.error.message,
                })
              }
            />
          )}
        </Field>
        <ErrorM name={field} />
      </div>
    </div>
  );
};

export default FormStripeCardField;
